/**
 * BLE-kontrakt for WiFi-provisjonering av infoskjerm-player.
 *
 * Player-firmware (dabih-signage #41) bruker den åpne **Improv Wi-Fi**-
 * standarden. Selve GATT-skjemaet (service/karakteristikker, RPC-pakker,
 * tilstander) eies av Improv-spec-en og implementeres av `improv-wifi-sdk`
 * (`ImprovBluetoothLE`) — vi håndkoder ikke protokollen. Service-UUID-en
 * importeres derfra (`IMPROV_BLE_SERVICE`).
 *
 * Vi finner boksen via Improv-**service-UUID-en** (`IMPROV_BLE_SERVICE`), ikke et
 * eksakt BLE-navn – samme metode som improv-wifi.com. BLE-annonsen inneholder
 * ofte ikke (eller trunkerer) det fullstendige lokale navnet, så et navnefilter
 * er upålitelig (se dabih-web#13366). Enheten annonserer navnet `Trinnvis-<KODE>`
 * (koden er den 8-tegns spillerkoden fra entityView, playerCode); dette brukes
 * kun som et ekstra `namePrefix`-treff og til visning i UI.
 *
 * iOS/Safari har ikke Web Bluetooth → captive-portal er fallback der.
 *
 * Companion: dabih-web#13332, dabih-web#13366, dabih-signage#41 (docs/onboarding-improv-ble-contract.md).
 */

/**
 * Navne-prefiks enheten annonserer med: `Trinnvis-<KODE>` (f.eks.
 * `Trinnvis-A1B2C3D4`). Brukes som et ekstra `namePrefix`-filter i requestDevice
 * – hovedfilteret er Improv-service-UUID-en.
 */
export const DEVICE_NAME_PREFIX = 'Trinnvis-';
